import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import { SuccessMessage } from "sr/helpers/functions/SuccessMessage";
import ApiResponse from "sr/models/ApiResponse";
import { post } from "sr/utils/axios";

export const manageTaskSubmit = async (postData) => {
    try {
  return await post<ApiResponse<[]>>('/tasktrack', postData).then((res)=> {
    if(res?.success===true) {
        SuccessMessage('API.SUCCESS.WORKORDER.TASK.SUBMIT')
        return res
    }
    else {
        return null
    }
  })
}
catch(e) {
    HandleApiError(e)
}
};
